module.exports = __webpack_public_path__ + "img/craneFrontRightOutline.321b5dd6.svg";